import { LABELS, RESPONSE_FIELD } from '@modules/dashboard/components/giveaway-answer-modal/constant';
import { DynamicFormBuilderService } from '@modules/dynamic-form-builder/services/dynamic-form-module.service';
import {
  Component,
  Input,
  Output,
  EventEmitter,
  ViewChild
} from '@angular/core';
import cloneDeep from 'lodash/cloneDeep';
import { Fields } from '@modules/dynamic-form-builder/model/formBuilderInterface';
import { ApiCallService } from '@services/api-call.service';
import { APIENDPOINT } from '@core/api-url.enum';
import { CommonService } from '@shared/services/common.service';
import { CommonModule } from '@angular/common';
import { DynamicFormBuilderModule } from '@modules/dynamic-form-builder/dynamic-form-builder.module';
import { environment } from '@environments/environment';
@Component({
  selector: 'app-giveaway-answer-modal',
  templateUrl: './giveaway-answer-modal.component.html',
  styleUrls: ['./giveaway-answer-modal.component.scss'],
  standalone: true,
  imports: [CommonModule, DynamicFormBuilderModule]
})
export class GiveawayAnswerModal {
  @Input() modalHeader: string = LABELS.GIVEAWAY_RESPONSE_FORM;
  @Input() giveAwayData = null;
  @Output() canceled = new EventEmitter<void>();
  @Output() success = new EventEmitter<void>();

  @ViewChild('giveawayAnswer') giveawayAnswerModal;
  @ViewChild('successModal') successModal;

  labels = LABELS;
  form = null;
  formFields: Fields;
  isSubmitting = false;
  constructor(
    private readonly formService: DynamicFormBuilderService,
    private readonly apiCallService: ApiCallService,
    public readonly cs: CommonService
  ) {}
  ngOnInit() {
    if (this.cs.isBrowser){
      this.formFields = cloneDeep(RESPONSE_FIELD);
      this.form = this.formService.toFormGroup(this.formFields);
    }
  }

  openModal() {
    this.giveawayAnswerModal?.openModal();
  }
  closeModal() {
    this.giveawayAnswerModal?.closeModal();
  }

  handleCancel(isSuccess) {
    if (!isSuccess) {
      this.form.reset();
      this.closeModal();
      this.canceled.emit();
    }
  }
  confirmed() {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
    } else {
      this.submitAnswer();
    }
  }
  handleSuccess() {
    this.success.emit();
  }

  submitAnswer() {
    this.isSubmitting = true;
    this.apiCallService
      .put(
        APIENDPOINT.giveAwayAnswer(
          this.giveAwayData?.user?.gsi4pk,
          this.cs.encodeToUTF(this.giveAwayData.sk)
        ),
        this.form.value,
        true
      )
      .subscribe(
        () => {
          this.isSubmitting = false;
          this.closeModal();
          this.form.reset();

          this.successModal?.openModal();
        },
        (err) => {
          this.isSubmitting = false;
          this.cs.showErrorMessage(err.message);
        }
      );
  }

  openLink(url: string) {
    this.cs.openUrl(environment.websiteURL + url);
  }
}
